import { Routes, RouterModule} from '@angular/router';
import { NgModule } from '@angular/core';
import { SmarticoPromotionLogsComponent } from './smartico-promotion-logs/smartico-promotion-logs.component';
import { FasttrackPromotionLogsComponent } from './fasttrack-promotion-logs/fasttrack-promotion-logs.component';
import { FasttrackActivityLogsComponent } from './fasttrack-activity-logs/fasttrack-activity-logs.component';

const routes: Routes = [
  {
    path: 'smartico-promotion-logs',
    component: SmarticoPromotionLogsComponent
  },
  {
    path: 'fasttrack-promotion-logs',
    component: FasttrackPromotionLogsComponent
  },
  {
    path: 'fasttrack-activity-logs',
    component: FasttrackActivityLogsComponent
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  entryComponents: [
    FasttrackPromotionLogsComponent,
  ]
})

export class CRMRoutingModule { }
